import { render } from "./gameIntro.vue?vue&type=template&id=57255c8c"
import script from "./gameIntro.vue?vue&type=script&lang=js"
export * from "./gameIntro.vue?vue&type=script&lang=js"

import "./gameIntro.vue?vue&type=style&index=0&id=57255c8c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__